import { render } from "./IconLocalOffer.vue?vue&type=template&id=77ee0db1"
import script from "./IconLocalOffer.vue?vue&type=script&lang=js"
export * from "./IconLocalOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__